export default __webpack_public_path__ + "static/media/icon-home-update.d46063ca.svg";